const separateDaysByOpeningHours = (openingHours) => {
	let compressedOpeningHours = [];
	let lastDay;

	openingHours.forEach((day) => {
		if (lastDay?.dayOfWeek) {
			if (
				lastDay.openingTime?.opening === day.openingTime?.opening &&
				lastDay.openingTime?.closing === day.openingTime?.closing
			) {
				let lastBatch = compressedOpeningHours.at(-1);
				if (Array.isArray(lastBatch)) {
					lastBatch.push(day);
				}
			} else {
				if (day.openingTime) {
					compressedOpeningHours.push([day]);
				}
			}
		} else {
			if (day.openingTime) {
				compressedOpeningHours.push([day]);
			}
		}

		lastDay = day;
	});

	return compressedOpeningHours;
};

const compressSeparatedDays = (openingHours) => {
	let compressedDays = [];

	openingHours.forEach((dayGroup) => {
		let firstDay;
		let lastDay;

		firstDay = getTranslatedDay(dayGroup.at(0).dayOfWeek);
		lastDay = getTranslatedDay(dayGroup.at(-1).dayOfWeek);

		compressedDays.push({
			name: firstDay === lastDay ? firstDay : `${firstDay.slice(0, 3)}-${lastDay.toLowerCase()}`,
			openingTime: {
				opening: dayGroup.at(0).openingTime.opening.slice(0, 2),
				closing: dayGroup.at(0).openingTime.closing.slice(0, 2),
			},
		});
	});

	return compressedDays;
};

const getTranslatedDay = (day) => {
	return {
		MONDAY: "Mandag",
		TUESDAY: "Tirsdag",
		WEDNESDAY: "Onsdag",
		THURSDAY: "Torsdag",
		FRIDAY: "Fredag",
		SATURDAY: "Lørdag",
		SUNDAY: "Søndag",
	}[day];
};

const compressOpeningHours = (openingHours) => {
	let compressedOpeningHours = separateDaysByOpeningHours(openingHours);
	const compressedDays = compressSeparatedDays(compressedOpeningHours);

	return compressedDays;
};

export { compressOpeningHours };
